# NOTE: this file is a huge mess because it was copy/pasted from an old app and needs to be rewritten.

CrossSellBait = require '../../cross_sell_bait/frontend/cross_sell_bait'
initializeRichMarker = require '../../offers_map/frontend/vendor/richmarker-compiled.js'
MarkerTooltip = require '../../offers_map/frontend/marker_tooltip'

require './nearby_deals_map_carousel'

TEMPLATES =
  tooltip: require '../../offers_map/tooltip.html.mustache'
  mapMarker: require '../../offers_map/map_marker.html.mustache'
  dealsListAndMap: require '../deals_list_and_map.html.mustache'

MPP.NearbyDealsMap or= {}
MPP.NearbyDealsMap.markers = []

merchantName = null
nearbyDealsMapCarousel = null
centerMarker = null
infoWindow = null
bounds = null

customMapStyles = [
  {
    featureType: "all"
  }
  {}
  {
    featureType: "poi.business"
    stylers: [visibility: "off"]
  }
]

addStarMarker = (map, deal) ->
  hasDeals = $('#multiple-offers .mpp-deal-card').length > 0

  tooltipData =
    isMainMarker: true
    name: merchantName
    nameAlreadyEscaped: true
    formattedCategory: if not hasDeals then I18n.t('js.modules.nearby_deals.no_deal_available')

  data =
    label: '<span class="icon-star-filled"></span>'
    tooltipHtml: TEMPLATES.tooltip.render tooltipData

  $marker = $ TEMPLATES.mapMarker.render(data)
  $tooltip = $marker.find '.marker-tooltip'

  marker = new RichMarker
    position: new google.maps.LatLng deal.lat, deal.lon
    map: map
    draggable: false
    shadow: false
    content: $marker[0]

  tooltip = new MarkerTooltip
    marker: marker
    $hoverElement: $marker.find '.marker-label'
    $mapContainer: $('#map-canvas')
    $tooltip: $tooltip
    $marker: $marker

  # This is necessary so that we only calculate the tooltip position after the map and marker are loaded
  setTimeout (=> tooltip.show()), 1000

addDealMarker = (map, deal, label) ->
  data =
    label: label
    bhc:
      marker: "deal:#{deal.uuid}"

  $marker = $ TEMPLATES.mapMarker.render(data)

  $label = $marker.find '.marker-label'
  $label.mouseenter ->
    nearbyDealsMapCarousel.scrollToTile label

  new RichMarker
    position: new google.maps.LatLng deal.lat, deal.lon
    map: map
    draggable: false
    shadow: false
    content: $marker[0]

  $marker.find('.marker-label').click ->
    nearbyDealsMapCarousel.goToDealPage label

  $marker

setMarkers = (map, deals) ->
  if deals.length > 1
    for i in [1...deals.length]
      MPP.NearbyDealsMap.markers.push addDealMarker(map, deals[i], i)

  addStarMarker map, deals[0]

zoomToShowAllMarkers = (map, nearbyDeals) ->
  bounds = new google.maps.LatLngBounds()

  for deal in nearbyDeals
    bounds.extend(new google.maps.LatLng(deal.lat, deal.lon))

  map.fitBounds bounds

window.googleMapsNearbyDealsInitialize = ->
  initializeRichMarker()

  mapContainer = $('#map-canvas')
  centerLat = mapContainer.data('center-lat')
  centerLng = mapContainer.data('center-lng')

  nearbyDealsCarousel = $('.dealmap #nd-items')
  nearbyDeals = nearbyDealsCarousel.children('.nearby-deal-tile')

  nearbyDealsInfo = []
  nearbyDealsInfo.push {
    lat: centerLat
    lon: centerLng
  }

  for deal in nearbyDeals
    nearbyDealsInfo.push {
      uuid: $(deal).data('uuid')
      lat: $(deal).data('marker-lat')
      lon: $(deal).data('marker-lng')
    }

  if centerLat and centerLng and $('#map-canvas').length
    isDraggable = $(document).width() > 480 ? true : false
    mapOptions =
      center: new google.maps.LatLng(centerLat, centerLng)
      zoom: 12
      zoomControl: true
      zoomControlOptions:
        style: google.maps.ZoomControlStyle.SMALL
        position: google.maps.ControlPosition.LEFT_TOP
      mapTypeControl: false
      draggable: isDraggable
      scrollwheel: false
      disableDefaultUI: true
      mapTypeControlOptions:
        mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'mapStyle']

    map = new google.maps.Map(document.getElementById("map-canvas"), mapOptions)

    setMarkers map, nearbyDealsInfo
    zoomToShowAllMarkers map, nearbyDealsInfo

    styledMap = new google.maps.StyledMapType customMapStyles, { name: 'Styled Map' }
    map.mapTypes.set('mapStyle', styledMap)
    map.setMapTypeId('mapStyle')

removeNearbyDeals = ->
  $('.mpp-container').addClass 'no-explore-nearby'
  $('section.nearby-deals').remove()

initialize = ->
  nearbyDealsMapCarousel = new MPP.NearbyDealsMap.Carousel '#nd-items', '#scrollable-list'

  $('.nearby-deal-tile').on 'click', ->
    dealUrl = $(this).find('figcaption a').attr('href')
    window.location = dealUrl

  # We hide the maps on phones, so don't load Google Maps if map is not present.
  return unless $('#map-canvas').length
  mapProxyBase = $('#map-canvas').data 'map-url'

  Groupon.Utils.GoogleMaps.load window.googleMapsNearbyDealsInitialize

fetchDealsAndRender = ({ showMap }, cb) ->
  merchantSlug = window.location.pathname.match(/\/biz\/(.+)/)?[1]
  return removeNearbyDeals() unless merchantSlug?

  request = $.get "/merchant-page/nearby-deals/#{merchantSlug}", (res) ->
    templateData = res?.data?.nearbyDeals

    if not templateData?
      removeNearbyDeals() if showMap
      return

    # trigger an event so that Merchant Specials or other modules can use this data
    $('.mpp-container').trigger 'nearby-deals-loaded', [templateData]

    return cb() unless showMap

    $nearbyDeals = $ 'section.nearby-deals'
    showBait = $nearbyDeals.data('show-bait') is true

    templateData.translate = templateData.t = -> (text) -> I18n.translate text
    templateData.showBait = showBait
    nearbyDealsHtml = TEMPLATES.dealsListAndMap.render templateData

    $nearbyDealsBox = $nearbyDeals.find '.nearby-deals-box'
    $nearbyDealsBox.html nearbyDealsHtml
    $nearbyDealsBox.removeClass 'loading'
    $nearbyDealsBox.removeClass 'gig-spinner'
    $nearbyDealsBox.removeClass 'gig-spinner-brnd'

    $showMore = $nearbyDeals.find '.show-more-nearby-deals'
    if $showMore.length > 0
      $showMore.click ->
        $showMore.hide()
        $nearbyDeals.find('.hide-until-show-more').slideDown()

    if showBait and Modernizr.mq '(min-width: 768px)'
      setTimeout (->
        new CrossSellBait { $offers: $nearbyDeals }
      ), 1000

    cb()

  request.fail ->
    removeNearbyDeals() if showMap

moveWidgetInit = (forceDesktop) ->
  $nearbyDeals = $ '.mpp-container section.nearby-deals'
  $desktopWrapper = $ '.mpp-container .nearby-deals-desktop'
  $mobileWrapper = $ '.mpp-container .nearby-deals-mobile'

  if $mobileWrapper.length > 0
    debounceTimeout = null
    $(window).on 'resize', ->
      clearTimeout(debounceTimeout) if debounceTimeout?
      debounceTimeout = setTimeout (-> moveWidget($nearbyDeals, $desktopWrapper, $mobileWrapper, forceDesktop)), 250

    moveWidget $nearbyDeals, $desktopWrapper, $mobileWrapper, forceDesktop

moveWidget = ($nearbyDeals, $desktopWrapper, $mobileWrapper, forceDesktop) ->
  # On Mobile, when the place has no offers, we move the Nearby Deals widget to the top.
  if Modernizr.mq('(min-width: 768px)') or forceDesktop
    return unless $desktopWrapper.find($nearbyDeals).length is 0
    $desktopWrapper.html $nearbyDeals
    $mobileWrapper.find($nearbyDeals).remove()
  else
    return unless $mobileWrapper.find($nearbyDeals).length is 0
    $mobileWrapper.html $nearbyDeals
    $desktopWrapper.find($nearbyDeals).remove()

MPP.NearbyDealsMap.init = (options) ->
  merchantName = options.merchantName
  forceDesktop = options.forceDesktop

  fetchDealsAndRender (options), ->
    return unless options.showMap
    initialize()
    moveWidgetInit(forceDesktop)
    GIG.Utils.truncateElements '#scrollable-list'


$ ->
  return unless $('.mpp-container').hasClass('has-nearby-deals')

  place = $('.mpp-container').data()
  forceDesktop = $('.mpp-container').hasClass 'force-desktop'

  MPP.NearbyDealsMap.init({
    showMap: $('.mpp-container .nearby-deals').length > 0
    merchantName: place.placeName
    forceDesktop
  });
